import script from "./scrollTable.vue?vue&type=script&setup=true&lang=js"
export * from "./scrollTable.vue?vue&type=script&setup=true&lang=js"

import "./scrollTable.vue?vue&type=style&index=0&id=61866da0&lang=less"

const __exports__ = script;

export default __exports__